import { TXTWCL_The_following_characters_are_n_ELL } from '../translations';

export const validateAllowedCharacters =
  (validator: RegExp, validCharacters: RegExp) => (value: string) => ({
    valid: !!value && validator.test(value),
    message: {
      ...TXTWCL_The_following_characters_are_n_ELL,
      values: { 0: value?.replace(validCharacters, ' ') }
    }
  });
